// src/components/OurStrengths/OurStrengths.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './OurStrengths.css';

// --- IMPORT ASSETS ---
// Replace these paths with your actual asset locations
import iconRobot from '../../../assets/About/OurStrength/carbon_machine-learning.png';
import iconShield from '../../../assets/About/OurStrength/shield-check.png';
import iconCycle from '../../../assets/About/OurStrength/refresh-ccw.png';
import factoryImg from '../../../assets/About/OurStrength/features-box-image.jpg.png';

const OurStrengths = () => {


  return (
    <section className="strength-section">
      <Container>
        {/* HEADER ROW */}
        <Row className="align-items-start mb-4">
          <Col lg={7} md={12}>
            <span className="str-label">Our Strengths</span>
            <h2 className="str-heading">
              Core Strengths in <strong>Automotive<br />Manufacturing</strong>
            </h2>
          </Col>
          <Col lg={5} md={12}>
            <p className="str-desc-top">
              Dynamic Stamping combines advanced manufacturing infrastructure, a strong in-house tool room, disciplined quality systems, and skilled manpower to deliver consistent automotive components.
            </p>
          </Col>
        </Row>

        {/* 2x2 GRID LAYOUT */}
        <div className="strength-grid-container">

          {/* ITEM 1: TOP LEFT */}
          <div className="strength-item item-1">
            <img src={iconRobot} alt="Advanced Capability" className="str-icon" />
            <h3 className="str-title">Advanced Manufacturing Capability</h3>
            <p className="str-text">
              High-precision stamping presses, robotic welding systems, and in-house tooling ensure dimensional accuracy and repeatability across all products.
            </p>
          </div>

          {/* ITEM 2: TOP RIGHT */}
          <div className="strength-item item-2">
            <img src={iconShield} alt="Quality Standards" className="str-icon" />
            <h3 className="str-title">Uncompromising Quality Standards</h3>
            <p className="str-text">
              Certified to ISO 9001 and IATF 16949, our processes are supported by robust inspection systems and continuous process monitoring.
            </p>
          </div>

          {/* ITEM 3: BOTTOM LEFT */}
          <div className="strength-item item-3">
            <img src={iconCycle} alt="Continuous Improvement" className="str-icon" />
            <h3 className="str-title">Continuous Improvement & Engineering Support</h3>
            <p className="str-text">
              Through tooling optimization, engineering support, and lean manufacturing practices, we improve productivity, reduce defects, and meet evolving customer requirements.
            </p>
          </div>

          {/* ITEM 4: BOTTOM RIGHT (IMAGE) */}
          <div className="strength-img-box">
            <img src={factoryImg} alt="Factory Interior" className="strength-full-img" />
          </div>

        </div>
      </Container>
    </section>
  );
};

export default OurStrengths;